export default class ObjectMerger {
  static applyDefaults<T>(data: T, defaults: T): T {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result: any = {};
    for (const key in defaults) {
      if (typeof defaults[key] === "object" && defaults[key] !== null) {
        result[key] = this.applyDefaults(data?.[key], defaults[key] as NonNullable<T>[Extract<keyof T, string>] | undefined) 
      } else {
        result[key] = data?.[key] ?? defaults[key];
      }
    }
    return result as T;
  }
}
